import React from "react";
import { RouteObject } from "react-router-dom";
import { SubscriptionPage } from "./ui";
import CheckoutPage from "../../features/subscription/checkout/ui/CheckoutPage";

export const subscriptionRoute: RouteObject = {
  path: "/subscription",
  element: <SubscriptionPage />,
  children: [
    {
      path: "checkout",
      element: <CheckoutPage />,
    },
  ],
};

export default subscriptionRoute;
